import { Search } from '@mui/icons-material';
import {
  Box,
  Button,
  CircularProgress,
  Input,
  Stack,
  Typography,
  useTheme
} from '@mui/material';
import {
  ChatBubble,
  CompaniesSummaryCard,
  CompanyFilter,
  CompanyTable,
  CustomIcons
} from 'modules';

import {
  Suspense,
  useRef
} from 'react';
import {
  Outlet,
  useLocation
} from 'react-router-dom';

import * as ds from './dataService';


export type CompaniesActivityProps = {};

export const CompaniesActivity = (props: CompaniesActivityProps) => {
  const location = useLocation();
  const slideRef = useRef<HTMLDivElement>(null);


  const theme = useTheme();

  const { form } = ds.useQuery();

  const handleUpdateQueryFilter = (trends: typeof form['formState']['trends']) => {
    form.dispatch({
      type: 'UPDATE',
      payload: {
        property: 'trends',
        value: trends
      }
    });
  };



  if (location.pathname.endsWith('company')) {
    return (
      <Box>
        <CompaniesSummaryCard.FC />

        <Suspense fallback={<CircularProgress />}>
          <Stack
            gap={2}
            sx={{
              marginTop: '1.5rem',
              paddingBottom: '1rem',
              bgcolor: 'white',
              borderRadius: '1rem'
            }}
          >
            {/* Company Table header section */}
            <Box
              gap={2}
              borderBottom={`1px solid ${theme.palette.gray.light10}`}
              sx={{
                px: '1rem'
              }}
            >
              <Box
                paddingY='.75rem'
                display='flex'
                flexDirection='row'
                alignItems='center'
              >
                <Typography
                  variant='tableTitle'
                >
                  Company Profiles
                </Typography>

                {/* Button group */}
                <Stack
                  direction='row'
                  flexWrap='wrap'
                  justifyContent='flex-end'
                  columnGap='.75rem'
                  flex='3 1 0'
                >
                  {/* CompaniesSearchBar */}
                  <Input
                    value={form.formState.freeTextSearch}
                    onChange={(e) => form.dispatch({
                      type: 'UPDATE',
                      payload: {
                        property: 'freeTextSearch',
                        value: e.currentTarget.value
                      }
                    })}
                    placeholder='Find(stock)'
                    startAdornment={<Search />}
                  />

                  <Button
                    variant='contained'
                    color='primary'
                    onClick={() => {
                      form.dispatch({
                        type: 'UPDATE',
                        payload: {
                          property: 'filter',
                          value: !form.formState.filter
                        }
                      });
                    }}
                    startIcon={(
                      <CustomIcons.MediumIcon.FC
                        icon='FILTER'
                        stroke={theme.palette.gray['light']}
                      />
                    )}
                  >
                    Idea Generation
                  </Button>
                </Stack>
              </Box>

              {form.formState.filter && (
                <CompanyFilter.FC
                  form={form}
                  handleUpdateQueryFilter={handleUpdateQueryFilter}
                />
              )}
            </Box>

            {/* Chat bubble + company table */}
            <Stack
              gap={2}
              sx={{
                px: '1rem'
              }}
            >
              {!form.formState.filter && (
                <ChatBubble.FC
                  slideRef={slideRef}
                  text='Hi! 👋 I am Sherlock. In order to start, please select a company below to gain deep company insights'
                  role='SHERLOCK'
                  variant='info'
                />
              )}

              <Box
                ref={slideRef}
              >
                <CompanyTable.FC
                  formState={form.formState}
                />
              </Box>
            </Stack>

          </Stack>
        </Suspense>
      </Box>
    );
  } else {
    return <Outlet />;
  }
};
